import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
} from "../../Util/authRedirect";
import { isOrganisationGroupUser, hasMemberOrganisationAccess } from "../../OrganisationGroups/utils/roleAccess";

const ProtectedRoutes = () => {
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const dataofstore = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(dataofstore);

  if (!rehydrated) return <LoaderComponent />;

  if (!authToken) return <Navigate to="/" replace />;

  if (!hasAuthenticatedUserData(dataofstore)) return <LoaderComponent />;

  const isOnlyOrganisationUser = isOrganisationGroupUser(dataofstore) && !hasMemberOrganisationAccess(dataofstore);

  return dataofstore?.role !== "Teacher" && !isOnlyOrganisationUser ? (
    <Outlet />
  ) : (
    <Navigate to={getAuthenticatedHomeRoute(dataofstore)} replace />
  );
};

export default ProtectedRoutes;
